import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Col, Row, Pagination } from "react-bootstrap";
import { NavLink, Outlet, useOutletContext } from "react-router-dom";
import Chart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { getPrintRequestsOwnerId, getPrintRequestsUserId, getTransactionFromUserId, getUserEarningFromUserId } from "store/actions";
import { Oval } from 'react-loader-spinner'
import { Input, PaginationItem, PaginationLink } from "reactstrap";
import { coversion } from "helpers/constants";
export default function Earnings(props) {
  const user_id = useSelector((s) => s?.Login?.user?._id);
  const { role } = useSelector((s) => s?.Login?.user);
  const { transactionsFromUserID, loading, userEarning } = useSelector((s) => s?.Transactions)
  var { printRequsets, printRequestFromOwnerId } = useSelector((s) => s?.Print)
  const {fiat_total_earning} = useSelector((s)=> s?.Login?.user)

  var printLoading = useSelector((s) => s?.Print?.laoding)
  const [buySellData, setBuySellData] = useState([])
  const [totalEarning, setTotalEarning] = useState([])
  const [totalFiatEarningInDollar, setTotalFiatEarningInDollar] =useState(0)
  const [totalPrintAmountMatic, setTotalPrintAmountMatic] = useState(0)
  const dispatch = useDispatch()
  useEffect(() => {
    if (user_id) {
      dispatch(getPrintRequestsOwnerId({ owner_id: user_id }))
    }
  }, [user_id, dispatch])
  useEffect(() => {
    if (user_id) {
      let body = {}
      body.user_id = user_id
      body.buySell = true
      if (user_id) {
        dispatch(getTransactionFromUserId(body))
      }
    }
  }, [user_id, dispatch])

  useEffect(() => {
    if (user_id) {
      let body = {}
      body.user_id = user_id
      if (user_id) {
        dispatch(getUserEarningFromUserId(body))
      }
    }
  }, [user_id, dispatch])


  useEffect(() => {
    setBuySellData(transactionsFromUserID?.filter((item, index) => item.sale_type === "buy"))
    let totalEarning = 0;
    for (let i = 0; i < transactionsFromUserID.length; i++) {
      if (transactionsFromUserID[i].seller_id === user_id && transactionsFromUserID[i].sale_type !== "minted" && transactionsFromUserID[i].sale_type !== "bid") {
        totalEarning += Number(transactionsFromUserID[i]?.price) * Number(transactionsFromUserID[i]?.no_of_copies) * 0.8 + Number(transactionsFromUserID[i]?.seller_disccount_amount)
      }
    }
    setTotalEarning(totalEarning)
  }, [transactionsFromUserID, user_id])
  const state = {
    options: {
      chart: {
        height: 350,
        id: "basic-bar"
      },
      xaxis: {
        categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999],
      },
      stroke: {
        show: true,
        curve: 'smooth',
        lineCap: 'butt',
        colors: undefined,
        width: 3,
        dashArray: 0,
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        show: true,
        borderColor: '#90A4AE',
        strokeDashArray: 0,
        position: 'back',
        xaxis: {
          lines: {
            show: false
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        },
        row: {
          colors: undefined,
          opacity: 0.5
        },
        column: {
          colors: undefined,
          opacity: 0.5
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ['#90A4AE', 'transparent'], // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: .2,
        stops: [0, 50, 100],
        colorStops: [0, 50, 100]
      }
    },
    series: [
      {
        name: "High - 2013",
        data: [28, 80, 90, 60, 75, 50, 65, 87, 54]
      },
      // {
      //   name: "Low - 2013",
      //   data: [12, 11, 14, 18, 17, 13, 13]
      // }
    ],
  };
  const [timezone, setTimezone] = useState()
  useEffect(() => {
    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(timezoneString)
  }, [])


  useEffect(() => {
    const func = async () => {
      if (printRequestFromOwnerId && printRequestFromOwnerId.length > 0) {
        console.log("fadfasdfasdfa", printRequestFromOwnerId)
        const totalPrintAmountdollar = printRequestFromOwnerId.reduce((acc, request) => {
          if (request?.payment_method === "Credit Card") {
            return acc; 
          }
          return acc + Number(request?.seller_earning || 0);
        }, 0);
        // const totalPrintAmountFiatDollar  = printRequestFromOwnerId.reduce((acc, request) => {
        //   if (request?.payment_method !== "Credit Card") {
        //     return acc; 
        //   }
        //   return acc + Number(request?.seller_earning || 0);
        // }, 0);
        // setTotalFiatEarningInDollar(totalPrintAmountFiatDollar)
        console.log("4324341234123", totalPrintAmountdollar)
        const maticAmt = await coversion(totalPrintAmountdollar, "USDk", "MATIC");
        setTotalPrintAmountMatic(Number(maticAmt).toFixed(4));
      } else {
        setTotalPrintAmountMatic(0.0000);
      }
    };

    func();
  }, [printRequestFromOwnerId]);


  // pagination
  const [dataLength, setDataLength] = useState([]);
  const [dataAfterPagination, setDataAfterPagination] = useState([]);
  var [values, setValues] = useState(10);
  var [sNoValue, setSNovalue] = useState(0);
  useEffect(() => {
    var x = 0;
    if (buySellData?.length < 9) {
      x = 1;
    } else {
      x = Math.ceil(buySellData.length / 10);
    }
    for (let i = 1; i <= x; i++) {
      if (!dataLength.includes(i)) {
        dataLength.push(i);
      }
    }
  }, [buySellData]);

  useEffect(() => {
    let arr = [];
    setSNovalue(values - 10);
    for (let i = values - 10; i < values; i++) {
      if (buySellData[i]) {
        arr.push(buySellData[i]);
      }
    }
    setDataAfterPagination(arr);
  }, [values, buySellData]);


  const handlePagination = (val) => {
    var valu = 0;
    if (val === "<<") {
      valu = 10;
    } else if (val === "<") {
      valu = parseInt(values) - 10;
    } else if (val === ">" && sNoValue / 10 < values) {
      valu = (parseInt(values / 10) + 1) * 10;
    } else if (val === ">>" && values < buySellData.length) {
      // setSNovalue(buySellData.length)
      valu = Math.ceil(buySellData.length / 10) * 10;
    } else {
      valu = parseInt(val) * 10;
    }
    setValues(valu);
  };



  return (
    <Row>
      {(loading || printLoading) &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      {/* <Col lg={12} className="mb-4">
        <div className="d-flex w-100 align-items-center justify-content-between flex-wrap">
          <h1 className="mb-0 ">My Earnings</h1>
          <NavLink to={'../withdrawal-fiet'} ><button className="WithdrawFiat">Withdraw Fiat</button></NavLink>
        </div>
      </Col> */}

      <Col lg={12} className="mb-4">
        <Row>
          <Col lg={4} className="mb-4">
            <div className="totalEarning d-flex justify-content-between">
             <div>
             <h2>Total Earning</h2>
             <h3 className="mt-3"> 
                {Number(Number(userEarning?.totalUserEarning|| 0 ) + Number(totalPrintAmountMatic || 0)).toFixed(6)} POL
              </h3>
             </div>
             {/* <div> </div> */}
            </div>
          </Col>
          {role !== "USER" && (
            <>
            <Col lg={4} className="mb-4">
            <div className="totalEarning royaltyEarning">
            <div>
              <h2>Royalties Earning</h2>
              <h3 className="mt-3">$ 0</h3>
            </div>
            </div>
          </Col> 
          {/* <Col lg={4} className="mb-4">
            <div className="totalEarning fietEarning">
            <div>
              <h2>Fiat Earning</h2>
              <h3 className="mt-3">$ {Number(fiat_total_earning?.toFixed(2))}</h3>
            </div>
            </div>
          </Col> */}
          </>
          )
          }
          {buySellData.length < 0 ? (
            <Col lg={12} className="mb-4">
              <div className="NoTransection py-5">
                <img src={'../../images/svg/transectionHistory.svg'} width={170} alt="" />
                <h2>No transaction history yet!</h2>
                <h3>Go check out the marketplace and buy some cool items!</h3>
              </div>
            </Col>)
            :
            (<Col lg={12} className="mb-4">
              <div className="dahboardBox">
                <h5 className="fw-semibold border-bottom pb-3">Activity</h5>
                <div className="table-responsive tableNft">
                  <table>
                    <thead>
                      <tr>
                        <td className="text-center">No.</td>
                        <td>Event</td>
                        <td>Artwork Name</td>
                        <td>Price</td>
                        <td>Quantity</td>
                        <td>Method</td>
                        <td>From</td>
                        <td>To</td>
                        <td>Date</td>
                        {/* <td className="text-center">View</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {dataAfterPagination.length > 0 ? (
                        <>
                          {dataAfterPagination && dataAfterPagination.map((item, index) =>
                            <tr>
                              <td className="text-center">{sNoValue += 1}</td>
                              {(item?.seller_id === user_id) ?
                                <td>Sold</td> :
                                <td>Bought</td>
                              }
                              <td><img className="nftimge" alt="" src={item?.nft_id?.image_id?.image?.link} /> {item?.nft_id?.name}</td>
                              <td>{item?.price} POL</td>
                              <td>{item?.no_of_copies}</td>
                              <td>Fiat</td>

                              <td>{item?.from?.substring(0, 5)}.....{item?.from?.substring(item?.from?.length - 4, item?.from?.length)}</td>
                              <td>{item?.to?.substring(0, 5)}.....{item?.to?.substring(item?.to?.length - 4, item?.to?.length)}</td>
                              <td>{new Date(item?.created_date).toLocaleString('en-IN', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true, timezone: timezone })}
                              </td>
                              {/* <td className="text-center">
                        <button className="btn border-0 "><i className="fa-regular fa-eye"></i></button>
                        </td> */}
                            </tr>)}
                        </>
                      ) : (
                        <>
                          <tr>
                            <td className="text-center py-4" colSpan={8}>No Data Available</td>
                          </tr>
                        </>
                      )}

                    </tbody>
                  </table>
                </div>
              </div>
            </Col>)}
        </Row>

        <Col lg={12} className="text-end">
          <Pagination className="paginationNew" aria-label="Page  navigation example">
            {values > 10 &&
              <div className="d-flex align-items-center gap-2">
                <PaginationItem >
                  <PaginationLink
                    first
                    href="#"
                    onClick={() => handlePagination("<<")}
                  />
                </PaginationItem>
                <PaginationItem >
                  <PaginationLink
                    href="#"
                    previous
                    onClick={() => handlePagination("<")}
                  />
                </PaginationItem>
              </div>
            }
            {dataLength && dataLength.map((item) =>
              <PaginationItem className={parseInt(item) === (values / 10) ? "active" : ""}>
                <PaginationLink href="#" onClick={() => handlePagination(item)}>
                  {item}
                </PaginationLink>
              </PaginationItem>
            )}
            {values < buySellData.length &&
              <div className="d-flex">
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    next
                    onClick={() => handlePagination(">")}
                  />
                </PaginationItem>
                <PaginationItem>
                  <PaginationLink
                    href="#"
                    last
                    onClick={() => handlePagination(">>")}
                  />
                </PaginationItem>
              </div>
            }
          </Pagination>
        </Col>
      </Col>
    </Row>
  );
}